<template>
    <div class="preview">
        <FullScreen
            ref="fullscreen"
            style="width: 100%; height: calc(100%)"
            @fullScreenin="isFull = true"
            @fullScreenOut="isFull = false"
            @dblclick.native.capture="dblclick($event)"
        >
            <div class="preBox" @mouseover="Mouseover(1)" @mouseleave="Mouseleave(0)">
                <video
                    :src="dataUrl"
                    controls
                    autoplay
                    :style="{ maxHeight: pageType === 'ault' ? '100%' : '360px' }"
                    class="fullVideo 'video-fit'"
                    @click.stop="showFile"
                    v-if="type === 'video'"
                ></video>
                <!--  :class="{ 'video-fit': isFill }" -->
                <img
                    :src="dataUrl"
                    alt=""
                    @click.stop="showFile"
                    :style="{ maxHeight: pageType === 'ault' ? '100%' : '360px' }"
                    :class="{ 'img-ofsetHeight': overWidth, 'file-img': !overWidth }"
                    v-if="type === 'img'"
                />
                <div
                    @click="toOther(-1)"
                    v-if="showBtn && eventType === 'eventAult' && eventLeft"
                    class="left"
                >
                    <div class="el-icon-arrow-left"></div>
                </div>
                <div
                    @click="toOther(1)"
                    v-if="showBtn && eventType === 'eventAult' && eventRight"
                    class="right"
                >
                    <div class="el-icon-arrow-right"></div>
                </div>
            </div>
        </FullScreen>
    </div>
</template>

<script>
import { FullScreen } from '@CommonComponent';

import api from '../api';
import { getImgWidthHeight } from '../asset/js/common.js';

export default {
    name: 'Preview',
    components: { FullScreen },
    props: {
        fileUrl: {
            Type: String,
        },
        fileType: {
            Type: String,
        },
        eventType: {
            Type: String,
        },
        eventLeft: {
            type: Boolean,
        },
        eventRight: {
            type: Boolean,
        },
        pageType: {
            type: String,
            default: '',
        },
    },
    mounted() {},
    data() {
        return {
            type: 'img',
            dataUrl: this.fileUrl,
            isFill: true,
            overWidth: false,
            isFull: false,
            showBtn: false,
            allVideoType: [
                'mp4',
                'm3u8',
                'flv',
                'mov',
                'srt',
                'avi',
                'wmv',
                'mpeg',
                'm4v',
                'asf',
                'f4v',
                'rmvb',
                'rm',
                '3gp',
                'vob',
            ],
        };
    },
    methods: {
        showFile() {
            this.$emit('showFile');
        },
        dblclick(event) {
            console.log(event, this.isFull, 'event');
            this.isFull = true;
            if (this.isFull) {
                this.$refs.fullscreen.toggleFullCreeen();
                event.stopPropagation();
            }
        },
        getType() {
            if (this.allVideoType.includes(this.fileType)) {
                this.type = 'video';
            } else {
                this.type = 'img';
                getImgWidthHeight(this.dataUrl).then(
                    (res) => {
                        // 宽高比 3:4
                        if (res.width / res.height > 0.75) {
                            this.overWidth = true;
                        } else {
                            this.overWidth = false;
                        }
                    },
                    (reason) => {},
                );
            }
        },
        Mouseover() {
            this.showBtn = true;
        },
        Mouseleave() {
            this.showBtn = false;
        },
        toOther(el) {
            // 更新页面上的数据 -1上一个、1下一个
            this.$emit('updateEvent', el);
        },
    },
    watch: {
        fileUrl(newVal) {
            this.dataUrl = newVal; // 对父组件传过来的值进行监听，如果改变也对子组件内部的值进行改变
        },
        fileType(newVal) {
            this.getType();
        },
        eventLeft(newVal) {},
        eventRight(newVal) {},
    },
};
</script>

<style lang="scss" scoped>
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.preview {
    cursor: pointer;
    width: calc(100% - 0px);
    height: calc(100% - 0px);

    .preBox {
        position: relative;
        // width: calc(100% - 0px);
        height: calc(100% - 0px);
        overflow: hidden;
        // text-align: center;
        // line-height: 1;
        // font-size: 0;
        .left {
            position: absolute;
            left: 10px;
            top: 50%;
            cursor: pointer;
            transform: translateY(-50%);
            width: 80px;
            height: 80px;
            background: rgba(0, 0, 0, 0.5);
            opacity: 1;
            border-radius: 50%;
            &:hover {
                background-color: rgba(0, 0, 0, 0.7);
            }
            &::v-deep .el-icon-arrow-left {
                color: #fff;
                font-size: 30px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .right {
            position: absolute;
            right: 10px;
            cursor: pointer;
            top: 50%;
            transform: translateY(-50%);
            width: 80px;
            height: 80px;
            background: rgba(0, 0, 0, 0.54);
            opacity: 1;
            border-radius: 50%;
            &:hover {
                background-color: rgba(0, 0, 0, 0.7);
            }
            &::v-deep .el-icon-arrow-right {
                color: #fff;
                font-size: 30px;

                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .fullVideo {
            width: calc(100% - 0px);
            height: calc(100% - 0px);
            // object-fit:cover;
            // max-height: 360px;
        }
        .file-img {
            // width: calc(100% - 0px);
            max-width: 270px;
            // height: calc(75% - 0px);
            // max-height: 360px;
        }
        .img-ofsetHeight {
            // width: 100% !important;
            height: 100% !important;
            // max-height: 360px;
        }
        .video-fit {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
